import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getSubinventoryCodesByPlant } from '../../api/production-request-api/index.js';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook to fetch subinventory codes by plant.
 * @param {Local.GetSubinventoryCodesByPlantInput} input - The input parameters to retrieve the subinventory codes.
 */
export const useSubinventoryCodes = (input) => {
  const { apiReady } = useApiReady();

  return useQuery({
    queryKey: [QUERY_KEYS.SUBINVENTORY, input],
    queryFn: () => getSubinventoryCodesByPlant(input),
    enabled: Boolean(apiReady && input?.inventoryItemId && input?.organizationId),
  });
};
